<template>
    <v-container fluid>
      <v-row>
        <productsStock></productsStock>
      </v-row>
        <v-row>
            <v-col>
                <TableOrdersB2B></TableOrdersB2B>
            </v-col>
            <v-col>
                <TableServiceCenter></TableServiceCenter>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="6">
                <last-sales></last-sales>
            </v-col>
            <v-col sm="6">
                <last-orders></last-orders>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <pending-receipts></pending-receipts>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import LastOrders from "@/components/Dashboard/Widgets/LastOrders";
    import LastSales from "@/components/Dashboard/Widgets/LastSales";
    import PendingReceipts from "@/components/Dashboard/Widgets/PendingReceipts";
    import TableServiceCenter from "@/components/Dashboard/Widgets/TableServiceCenter";
    import TableOrdersB2B from "@/components/Dashboard/Widgets/TableOrdersB2B";
    import ProductsStock from "./Widgets/ProductsStock";

    export default {
        components: {
            LastOrders,
            LastSales,
            PendingReceipts,
            TableServiceCenter,
            TableOrdersB2B,
            ProductsStock
        },
        computed: {
            profile() {
                return User.getters.getProfileId
            }
        }
    }
</script>
